import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';

export class DownloadReceiptService {
    private client: QuestelServicesClient;

    constructor() {
        this.client = new QuestelServicesClient(store, "/api");
    }

    public async downloadReceipt(token: Guid): Promise<any> {
        var request = new Request(`/api/v1/ReceiptDownload/${token}`, {
            method: HttpMethodEnum.Get,
        });

        return fetch(request);
    }
}